import { render, staticRenderFns } from "./erm_board_help.vue?vue&type=template&id=ce86b49c&scoped=true&"
import script from "./erm_board_help.vue?vue&type=script&lang=js&"
export * from "./erm_board_help.vue?vue&type=script&lang=js&"
import style0 from "./erm_board_help.vue?vue&type=style&index=0&id=ce86b49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce86b49c",
  null
  
)

export default component.exports